import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import {
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";

const ScheduleBeneTransactionMultiApprovalCard = ({
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SideDrawerOpen,
  openBeneTxnDetailModal,
  setTxnId,
  setDatas,
}) => {
  const dispatch = useDispatch();
  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state?.beneTxnViewAccData);

  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError]);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "#30e5e4";
      case "approved":
        return "#4ddd37";
      case "denied":
      case "blocked":
        return "#ff5860";
      case "archived":
        return "#a3a3a3";
      case "rejected":
        return "#ff5860";
      default:
        return "#4ddd37";
    }
  };
  const getFormattedFrequency = (txn) => {
    const startDate = txn?.transaction_start_date;
    const frequency = txn?.frequency?.toLowerCase();

    if (!startDate || !frequency) return "";

    const dateObj = new Date(startDate);
    const day = dateObj.getDate();
    const weekday = dateObj.toLocaleString("en-IN", { weekday: "short" });
    const rawMonth = dateObj.toLocaleString("en-IN", { month: "short" });
    const month = rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1);

    const formatDate = (d) => `${d.getDate()} ${month}`;

    switch (frequency) {
      case "weekly":
        return `on ${weekday}`;
      case "monthly":
        return `on ${day}`;
      case "yearly":
      case "once":
        return `on ${formatDate(dateObj)}`;
      default:
        return "";
    }
  };

  const handleCardClick = (account) => {
    if (account.beneficiary_account_approval_status === "approved") {
      setselectAllCard(false);
      setSelectedTransactions((prevSelected) => {
        const cardAmount = Number(account.amount);
        const isSelected = prevSelected.includes(account.txn_id);

        if (isSelected) {
          setTotalAmount((prevAmount) => prevAmount - cardAmount);
          let data = selectedSendTransactions.filter((val) => {
            return val?.txn_id !== account.txn_id;
          });
          setSelectedSendTransactions(data);
          return prevSelected.filter((id) => id !== account.txn_id);
        } else {
          if (prevSelected.length < 20) {
            setTotalAmount((prevAmount) => prevAmount + cardAmount);
            setSelectedSendTransactions((prev) => [...prev, account]);
            return [...prevSelected, account.txn_id];
          } else {
            return prevSelected;
          }
        }
      });
    }
  };

  return (
    <>
      <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
        {data?.map((account, index) => (
          <CardContainer
            isDisabled={
              filterOpen ||
              account.beneficiary_account_approval_status === "pending"
                ? true
                : false
            }
            key={account?.txn_id}
            isSelected={selectedTransactions.includes(account.txn_id)}
            onClickHandler={() => handleCardClick(account)}
          >
            <card-body>
              <TextWithIcon
                type={"Text"}
                fontWeight={"var(--font-normal)"}
                text={account.scheduled_name}
                textColor={"var(--text-primary)"}
                subText="Schedule name"
                iconComponentArray={
                  account.beneficiary_account_approval_status !== "pending"
                    ? [
                        ...(account?.confidential_transaction === "Y"
                          ? [
                              {
                                icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                title: "confidential",
                                isDisabled: false,
                              },
                            ]
                          : []),

                        {
                          icon: selectedTransactions.includes(account?.txn_id)
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : ICONS?.NOTSELECTED_WITH_GREY_CIRCLE,
                          isDisabled: false,
                        },
                      ]
                    : []
                }
              />
              <TextWithIcon
                type={
                  account.beneficiary_account_approval_status === "pending"
                    ? "Text"
                    : "Amount"
                }
                fontWeight={"semibold"}
                text={
                  account.beneficiary_account_approval_status === "pending"
                    ? "Account approval pending"
                    : account?.amount
                }
                textColor={getStatusColor(
                  account.beneficiary_account_approval_status,
                )}
                subText={
                  account.beneficiary_account_approval_status === "pending"
                    ? "Account status"
                    : "Amount"
                }
              />
              <TextWithIcon
                type={"Text"}
                fontWeight={"var(--font-normal)"}
                text={account.beneficiary_account_name
                  ?.toLowerCase()
                  .split(" ")
                  .map(
                    (word) =>
                      word
                        .charAt(GlobalConfiguration.lengthCheckZero)
                        .toUpperCase() +
                      word.slice(GlobalConfiguration.lengthCheckOne),
                  )
                  .join(" ")}
                textColor={"var(--text-primary)"}
                subText="Account name"
              />

              <TextWithCTA
                btnText={
                  account?.beneficiary_account_approval_status === "pending"
                    ? "Approve account"
                    : "Additional details"
                }
                enabledBgColor={"var(--text-primary)"}
                enabledTextColor={"var(--primary-bg)"}
                handleFunction={(e) => {
                  e.stopPropagation();

                  setDatas(account);

                  if (!sessionStorage.getItem("q2p_token")) {
                    return;
                  }
                  if (
                    account.beneficiary_account_approval_status === "pending"
                  ) {
                    SideDrawerOpen(
                      account?.beneficiary_account_id,
                      account.txn_id,
                    );
                  } else {
                    openBeneTxnDetailModal();
                    setTxnId(account.txn_id);
                  }
                }}
                icon={ICONS?.ARROW_RIGHT_WHITE}
                isDisabled={filterOpen ? true : false}
                // text={account?.frequency}
                text={(() => {
                  const freq = account?.frequency?.toLowerCase();
                  const formattedFreq =
                    freq === "half_yearly"
                      ? "Half yearly"
                      : freq?.charAt(0).toUpperCase() + freq?.slice(1);
                  const formattedDate = getFormattedFrequency(account);

                  return formattedDate
                    ? `${formattedFreq}, ${formattedDate}`
                    : formattedFreq;
                })()}
                subText="Frequency"
                type={"Text"}
              />
            </card-body>
          </CardContainer>
        ))}
      </div>
    </>
  );
};

export default ScheduleBeneTransactionMultiApprovalCard;
